import React from "react";
import Contact from "@/components/ContactUs";
import { createClient } from "../../prismicio";
import Metadata from "@/components/Metadata";
import Layout from "@/components/Layout";

const ContactUs = ({ page, globals }) => {
  const pageData = page?.data;
  const commonComponents = globals?.data;

  const working = {
    title: pageData?.working_title,
    desc: pageData?.working_description,
    call_title: pageData?.working_call_us_title,
    call_caption: pageData?.working_call_us_caption,
    call_number: pageData?.working_call_us_nubmer,
    days: pageData?.working_hours,
  };

  return (
    <Layout data={commonComponents}>
      <Metadata
        title={pageData?.metadata_title}
        description={pageData?.metadata_desc}
        image={pageData?.metadata_image?.url}
        path="/contact-us"
      />
      <Contact
        caption={pageData?.caption}
        title={pageData?.title}
        description={pageData?.description}
        working={working}
      />
    </Layout>
  );
};

export default ContactUs;

export async function getStaticProps({ previewData }) {
  const client = createClient({ previewData });

  const page = await client.getSingle("contact_us_page");
  const globals = await client.getSingle("globals");

  return {
    props: {
      page,
      globals,
    },
  };
}
